// live
export const BASEURL = "https://api.fusionsuite.co.uk/api";
//dev
// export const BASEURL = "https://shopcart.fusiontesting.co.uk/api";
//local
// export const BASEURL = "http://127.0.0.1:8005/api";
// export const BASEURL = "https://crm-laravel-test.fusiontesting.co.uk/api";

// Shop
export const HARDWAREURL = BASEURL + "/getitems";
export const HARDWARE_CATEGORYURL = BASEURL + "/getcategory";


